import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import AkButton from '@atlaskit/button';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
export var PrimaryCTAContainer = _styled("div", {
  target: "eucncv10",
  label: "PrimaryCTAContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "17gow3k",
  styles: "min-width:106px;"
} : {
  name: "17gow3k",
  styles: "min-width:106px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9QcmltYXJ5Q1RBLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1CNkMiLCJmaWxlIjoiLi4vc3JjL1ByaW1hcnlDVEEuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuXG5pbXBvcnQgQWtCdXR0b24gZnJvbSAnQGF0bGFza2l0L2J1dHRvbic7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IFJlYWN0LCB7IFB1cmVDb21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB0eXBlIHsgTm9kZSB9IGZyb20gJ3JlYWN0JztcblxudHlwZSBQcm9wcyA9IHtcbiAgY2hpbGRyZW46IE5vZGUsXG4gIGhyZWY/OiBzdHJpbmcsXG4gIGlzRGlzYWJsZWQ6IGJvb2xlYW4sXG4gIGlzTG9hZGluZzogYm9vbGVhbixcbiAgb25DbGljaz86IChTeW50aGV0aWNFdmVudDxIVE1MTGlua0VsZW1lbnQ+KSA9PiB2b2lkLFxuICBidXR0b25JZD86IHN0cmluZyxcbiAgdGVzdElkPzogc3RyaW5nLFxufTtcblxuZXhwb3J0IGNvbnN0IFByaW1hcnlDVEFDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBtaW4td2lkdGg6IDEwNnB4O1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgUHJpbWFyeUNUQSBleHRlbmRzIFB1cmVDb21wb25lbnQ8UHJvcHM+IHtcbiAgc3RhdGljIHByb3BUeXBlcyA9IHtcbiAgICBjaGlsZHJlbjogUHJvcFR5cGVzLm5vZGUuaXNSZXF1aXJlZCxcbiAgICBocmVmOiBQcm9wVHlwZXMuc3RyaW5nLFxuICAgIGlzRGlzYWJsZWQ6IFByb3BUeXBlcy5ib29sLFxuICAgIGlzTG9hZGluZzogUHJvcFR5cGVzLmJvb2wsXG4gICAgb25DbGljazogUHJvcFR5cGVzLmZ1bmMsXG4gIH07XG5cbiAgc3RhdGljIGRlZmF1bHRQcm9wcyA9IHtcbiAgICBpc0Rpc2FibGVkOiBmYWxzZSxcbiAgICBpc0xvYWRpbmc6IGZhbHNlLFxuICB9O1xuXG4gIHJlbmRlciA9ICgpID0+IChcbiAgICA8UHJpbWFyeUNUQUNvbnRhaW5lcj5cbiAgICAgIDxBa0J1dHRvblxuICAgICAgICBhcHBlYXJhbmNlPVwicHJpbWFyeVwiXG4gICAgICAgIGhyZWY9e3RoaXMucHJvcHMuaHJlZn1cbiAgICAgICAgaXNMb2FkaW5nPXt0aGlzLnByb3BzLmlzTG9hZGluZ31cbiAgICAgICAgaXNEaXNhYmxlZD17dGhpcy5wcm9wcy5pc0Rpc2FibGVkfVxuICAgICAgICBvbkNsaWNrPXt0aGlzLnByb3BzLm9uQ2xpY2t9XG4gICAgICAgIHNob3VsZEZpdENvbnRhaW5lclxuICAgICAgICBpZD17dGhpcy5wcm9wcy5idXR0b25JZH1cbiAgICAgICAgdGVzdElkPXt0aGlzLnByb3BzLnRlc3RJZH1cbiAgICAgID5cbiAgICAgICAge3RoaXMucHJvcHMuY2hpbGRyZW59XG4gICAgICA8L0FrQnV0dG9uPlxuICAgIDwvUHJpbWFyeUNUQUNvbnRhaW5lcj5cbiAgKTtcbn1cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var PrimaryCTA = /*#__PURE__*/function (_PureComponent) {
  _inherits(PrimaryCTA, _PureComponent);

  var _super = _createSuper(PrimaryCTA);

  function PrimaryCTA() {
    var _this;

    _classCallCheck(this, PrimaryCTA);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/React.createElement(PrimaryCTAContainer, null, /*#__PURE__*/React.createElement(AkButton, {
        appearance: "primary",
        href: _this.props.href,
        isLoading: _this.props.isLoading,
        isDisabled: _this.props.isDisabled,
        onClick: _this.props.onClick,
        shouldFitContainer: true,
        id: _this.props.buttonId,
        testId: _this.props.testId
      }, _this.props.children));
    });

    return _this;
  }

  return PrimaryCTA;
}(PureComponent);

_defineProperty(PrimaryCTA, "propTypes", {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func
});

_defineProperty(PrimaryCTA, "defaultProps", {
  isDisabled: false,
  isLoading: false
});

export { PrimaryCTA as default };